module.exports = __webpack_public_path__ + "img/logo-css-preprocessors.62eab437.png";